var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _vm._m(0),
    _vm._v(" "),
    _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "vstack gap-6" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _vm._l(_vm.items, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-md-3 col-6 mb-3" },
                      [
                        _c(
                          "div",
                          { staticClass: "card shadow-3-hover cursor-pointer" },
                          [
                            _c("div", { staticClass: "px-1 py-3" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "row justify-content-between align-items-center",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-lg-6 col-12" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center font-semibold",
                                        },
                                        [
                                          _c("div", [
                                            _c("i", {
                                              staticClass: "text-lg me-3",
                                              class: item.icon,
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "ms-4" },
                                            [
                                              _c(
                                                "font",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "inherit",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "font",
                                                    {
                                                      staticStyle: {
                                                        "vertical-align":
                                                          "inherit",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.description
                                                        ) +
                                                          "\n                                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "d-block text-sm text-muted",
                                                },
                                                [_vm._v(_vm._s(item.name))]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-auto col-12 mt-4 mt-lg-0",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-between gap-6",
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "RoleUpdate",
                                                      params: { id: item.id },
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "cursor-pointer text-sm text-muted text-primary-hover font-semibold",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "bi bi-pencil-square me-2",
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.loading
                    ? _c("div", { staticClass: "col-12" }, [_vm._m(2)])
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "pt-6" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-sm col-12" }, [
              _c("h1", { staticClass: "h2 ls-tight" }, [
                _vm._v("Roles y permisos"),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header pb-0" }, [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("h5", { staticClass: "me-auto" }, [_vm._v("Administrar funciones")]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-sm text-muted mt-1" }, [
        _vm._v(
          "Administre los roles de su cuenta y otorgue a sus\n                            administradores solo los permisos necesarios."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c(
        "div",
        {
          staticClass: "spinner-border text-primary",
          attrs: { role: "status" },
        },
        [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }